import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdsCheckboxModule } from '@cds/ng-web-components/checkbox';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-cd-intragroup-transfer-checkbox',
  templateUrl: './cd-intragroup-transfer-checkbox.component.html',
  styleUrls: ['./cd-intragroup-transfer-checkbox.component.scss'],
  imports: [CdsCheckboxModule, FormsModule, ReactiveFormsModule, CdsLanguageModule],
})
export class CdIntragroupTransferCheckboxComponent implements OnInit {
  @Input() formControl?: FormControl;

  constructor() {}

  ngOnInit(): void {}
}
